import { Fragment, useSyncExternalStore, type ReactNode } from 'react';

import { currentLocale, onLocaleChanged } from '@web/i18n';

/**
 * Raiz sensível a idioma. O app traduz com `t()` imperativo (sem
 * `useTranslation`), então trocar o idioma exige REMONTAR a árvore: a `key`
 * faz o "recarregar a tela" sem derrubar o que um reload derrubaria — stores
 * zustand, `queryClient` e a sessão vivem fora da árvore e sobrevivem.
 */
export function LocaleRoot({ children }: Readonly<{ children: ReactNode }>): React.JSX.Element {
  const locale = useSyncExternalStore(onLocaleChanged, currentLocale, currentLocale);
  return <Fragment key={locale}>{children}</Fragment>;
}
